/**
 * Repository Factory
 * Composition root — the ONLY file that knows about the concrete apiClient.
 * Repositories depend on the IHttpClient interface, not the implementation.
 *
 * Usage (production):
 *   import { repositories } from '../api/createRepositories';
 *   const agents = await repositories.agents.getAgents();
 *
 * Usage (test):
 *   import { createRepositories } from '../api/createRepositories';
 *   const repos = createRepositories(mockClient);
 */

import { apiClient } from './client/apiClient';
import { AgentsRepository } from './data/repositories/agents/agentsRepository';
import { VoicesRepository } from './data/repositories/voices/voicesRepository';
import { ConversationsRepository } from './data/repositories/conversations/conversationsRepository';
import { TTSRepository } from './data/repositories/tts/ttsRepository';
import { DashboardRepository } from './data/repositories/dashboard/dashboardRepository';
import { ToolsRepository } from './data/repositories/tools/toolsRepository';
import { KnowledgebaseRepository } from './data/repositories/knowledgebase/knowledgebaseRepository';
import { WidgetRepository } from './data/repositories/widget/widgetRepository';
import { UsageRepository } from './data/repositories/usage/usageRepository';
import { PhonenumbersRepository } from './data/repositories/phonenumbers/phonenumbersRepository';
import { LivekitRepository } from './data/repositories/livekit/livekitRepository';

export function createRepositories(client) {
  return {
    agents: new AgentsRepository(client),
    voices: new VoicesRepository(client),
    conversations: new ConversationsRepository(client),
    tts: new TTSRepository(client),
    dashboard: new DashboardRepository(client),
    tools: new ToolsRepository(client),
    knowledgebase: new KnowledgebaseRepository(client),
    widget: new WidgetRepository(client),
    usage: new UsageRepository(client),
    phonenumbers: new PhonenumbersRepository(client),
    livekit: new LivekitRepository(client),
  };
}

/** Default singleton wired with the real apiClient */
export const repositories = createRepositories(apiClient);
